import { Link } from "@tanstack/react-router";

export function SiteFooter() {
  return (
    <footer className="border-t border-border/60 bg-muted/30 mt-16">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
        <div className="flex flex-col gap-4 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>
            Bevattningskartan är ett oberoende informationsprojekt. Verifiera
            alltid uppgifter mot din kommun eller VA-huvudman.
          </p>
          <div className="flex gap-4">
            <Link to="/api" className="hover:text-foreground transition-colors">
              API
            </Link>
            <Link to="/om" className="hover:text-foreground transition-colors">
              Om projektet
            </Link>
            <Link to="/faq" className="hover:text-foreground transition-colors">
              Vanliga frågor
            </Link>
            <Link
              to="/kallor"
              className="hover:text-foreground transition-colors"
            >
              Källor
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
